"use client";

import { useEffect, useState } from "react";

const CONTROLLER_URL = "https://studio.xcutiq.com";
const TARGET_ID = "ai-fabric-admin";
const SESSION_KEY = "xcutiq-studio:bridge-session:v2";

export function XcutiqStudioRemoteHost() {
  const [open, setOpen] = useState(false);
  const [frameUrl, setFrameUrl] = useState("");

  useEffect(() => {
    let session = window.sessionStorage.getItem(SESSION_KEY);
    if (!session) {
      session = window.crypto.randomUUID();
      window.sessionStorage.setItem(SESSION_KEY, session);
    }
    const url = new URL(CONTROLLER_URL);
    url.searchParams.set("target", TARGET_ID);
    url.searchParams.set("bridgeSession", session);
    url.searchParams.set("embedded", "1");
    setFrameUrl(url.toString());

    const toggle = (event: KeyboardEvent) => {
      if (event.ctrlKey && event.altKey && event.code === "KeyD" && !event.repeat) {
        event.preventDefault();
        setOpen((current) => !current);
      }
    };
    window.addEventListener("keydown", toggle, true);
    return () => window.removeEventListener("keydown", toggle, true);
  }, []);

  return (
    <>
      <button
        type="button"
        aria-label={open ? "Close XcutIQ StudIO" : "Open XcutIQ StudIO"}
        title="XcutIQ StudIO · Ctrl+Alt+D"
        onClick={() => setOpen((current) => !current)}
        style={{
          position: "fixed", right: 22, bottom: 22, zIndex: 2147483646,
          width: 52, height: 52, borderRadius: 16, border: "1px solid #2d7998",
          background: "#0c1b29", color: "#78defb", fontWeight: 800,
          boxShadow: "0 14px 44px rgba(0,0,0,.35)", cursor: "pointer",
        }}
      >
        XS
      </button>
      {open ? (
        <section
          role="dialog"
          aria-label="XcutIQ StudIO"
          style={{
            position: "fixed", right: 22, bottom: 84, zIndex: 2147483645,
            width: "min(720px, calc(100vw - 32px))", height: "min(780px, calc(100vh - 112px))",
            minWidth: 320, minHeight: 360, resize: "both", overflow: "hidden",
            border: "1px solid #304765", borderRadius: 16, background: "#07101b",
            boxShadow: "0 24px 90px rgba(0,0,0,.55)",
          }}
        >
          <header style={{ height: 42, display: "flex", alignItems: "center", justifyContent: "space-between", padding: "0 10px 0 14px", color: "#eaf5ff", background: "#0e1a29", borderBottom: "1px solid #26384f" }}>
            <strong style={{ fontSize: 13 }}>XcutIQ StudIO · {TARGET_ID}</strong>
            <span style={{ display: "flex", gap: 6 }}>
              <a href={frameUrl || CONTROLLER_URL} target="_blank" rel="noreferrer" style={{ color: "#75ddfb", fontSize: 12, padding: 6 }}>Open tab</a>
              <button type="button" aria-label="Close XcutIQ StudIO" onClick={() => setOpen(false)} style={{ border: 0, background: "transparent", color: "#eaf5ff", fontSize: 20, cursor: "pointer" }}>×</button>
            </span>
          </header>
          {frameUrl ? (
            <iframe
              src={frameUrl}
              title="XcutIQ StudIO controller"
              referrerPolicy="no-referrer"
              sandbox="allow-downloads allow-forms allow-popups allow-same-origin allow-scripts"
              style={{ display: "block", width: "100%", height: "calc(100% - 42px)", border: 0, background: "#070b14" }}
            />
          ) : null}
        </section>
      ) : null}
    </>
  );
}
